export default __webpack_public_path__ + "static/media/kamil-intro3.39adcfea.png";